<template>
  <div
    class="form-group"
    v-click-outside="hideDropdown"
  >
    <label class="form-label">Товар</label>

    <div class="search">
      <input
        v-model="search"
        type="text"
        ref="search-input"
        class="form-input"
        placeholder="Введите название товара"
        @focus="showDropdown"
      />

      <div
        v-if="isVisibleDropdown"
        class="search-dropdown"
      >
        <div
          v-for="(item, index) in filteredList"
          :key="`search-item-${index}`"
          class="search-item"
          @click="selectItem(item)"
        >
          <span class="search-item__count">{{ item.count }} шт.</span>
          <span class="search-item__name">{{ item.title }}</span>
          <span class="search-item__code">{{ item.code }}</span>
          <span class="search-item__price">
            <strong>{{ priceToFormat(item.price) }}</strong>
            <del v-if="Number(item.salePrice) > 0">{{ priceToFormat(item.price) }}</del>
          </span>
        </div>
      </div>

      <div
        v-if="isEmptySearch"
        class="search-dropdown"
      >
        <div class="search-empty">Товары не найдены</div>
      </div>
    </div>

    <div class="selected-item__list">
      <div
        v-for="(item, index) in selectedItems"
        :key="`selected-item-${index}`"
        class="selected-item"
      >
        <div class="selected-item__info">
          <div class="selected-item__name">{{ item.title }}</div>

          <div class="selected-item__controls">
            <div class="price-input">
              <input
                v-model.number="item.price"
                type="number"
                min="0"
              />
            </div>

            <button
              type="button"
              class="add-one-button"
              @click="addItem(item)"
            >
              +1
            </button>

            <button
              type="button"
              class="delete-button"
              @click="removeItem(item)"
            >
              Удалить
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { priceToFormat } from '@/helper'

export default {
  name: 'Search',
  data () {
    return {
      search: null,
      isVisibleDropdown: true,
      selectedItems: []
    }
  },
  props: {
    list: {
      type: Array,
      default: () => ([])
    },
    preSelectedItems: {
      type: Array,
      default: () => ([])
    },
  },
  computed: {
    filteredList () {
      if (!this.search) {
        return this.list
      }

      const search = this.search.toLowerCase()

      return this.list.filter(product => product.titleWithCodePrice.toLowerCase().includes(search))
    },
    isEmptySearch () {
      return this.isVisibleDropdown && this.search && !this.filteredList.length
    }
  },
  watch: {
    selectedItems: {
      deep: true,
      handler (items) {
        // TODO: Надо оптимизировать, тк вызывается на каждое изменение объекта
        this.$emit('update', items.map(item => ({
          ...item,
          internalId: crypto.randomUUID()
        })))
      }
    },
    preSelectedItems: {
      immediate: true,
      handler (items) {
        if (items.length > this.selectedItems.length) {
          this.selectedItems = [...items].map(item => ({
            ...item,
            internalId: crypto.randomUUID()
          }))
        }
      }
    }
  },
  methods: {
    priceToFormat,
    selectItem (item) {
      this.selectedItems.push({
        ...item,
        internalId: crypto.randomUUID()
      })

      this.search = ''
      this.isVisibleDropdown = false
    },
    addItem (item) {
      this.selectedItems.push({
        ...item,
        internalId: crypto.randomUUID()
      })
    },
    removeItem (item) {
      this.selectedItems = this.selectedItems.filter(({ internalId }) => internalId !== item.internalId)
    },
    showDropdown () {
      this.isVisibleDropdown = true
    },
    hideDropdown () {
      this.isVisibleDropdown = false
    }
  }
}
</script>

<style lang="scss" src="./style.scss" />
